var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.543 48.12c.096.384.144.672.144.864 0 .624-.216 1.128-.648 1.512a2.205 2.205 0 01-1.512.576c-.48 0-.912-.12-1.296-.36a3.007 3.007 0 01-.792-1.08l-5.4-13.176H9.64L4.311 49.632c-.384.96-1.032 1.44-1.944 1.44-.672 0-1.176-.168-1.512-.504C.52 50.232.327 49.776.28 49.2v-.216c0-.288.024-.504.072-.648L19.36 1.824c.384-.96 1.104-1.44 2.16-1.44.48 0 .888.144 1.224.432.384.24.672.576.864 1.008L42.543 48.12zM31.311 32.208L21.231 7.584l-9.936 24.624h20.016z",
    fill: "currentColor"
  })));
}
export default SvgA;